/* Speed Junkies HQ - "Choose how you want to enter" landing page.
   Scoped to [data-sj-enter]. Adding to cart is handled by the theme's own
   <product-form-component>, so the existing cart drawer, cart totals and entry
   calculations behave exactly as they do everywhere else on the site.

   This file only handles:
     - category tabs
     - quantity steppers
     - variant selects (swapping the hidden variant id on the theme form)
     - live entry amounts pulled from the store's own entry endpoints
     - the "added" confirmation + running cart subtotal bar
*/
(function () {
  'use strict';
  if (window.__sjEnterInit) return;
  window.__sjEnterInit = true;

  var MULT_URL = '/apps/api/current-multiplier';
  var ENTRIES_URL = '/apps/api/product-entries';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function nf(n) { try { return Number(n).toLocaleString(); } catch (e) { return String(n); } }

  /* ------------------------------------------------ money ----------- */
  var MONEY_FMT = null;
  function money(cents) {
    if (MONEY_FMT === null) {
      var root = $('[data-sj-enter]');
      MONEY_FMT = (root && root.getAttribute('data-money-format')) || '${{amount}}';
    }
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY_FMT
      .replace('{{amount}}', parts.join('.'))
      .replace('{{amount_no_decimals}}', parts[0])
      .replace('{{amount_with_comma_separator}}', parts.join(','))
      .replace('{{amount_no_decimals_with_comma_separator}}', parts[0]);
  }

  /* ------------------------------------------------ tabs ------------- */
  function initTabs(root) {
    $$('[data-sj-tabs]', root).forEach(function (bar) {
      if (bar.__sj) return;
      bar.__sj = true;
      var tabs = $$('[data-sj-tab]', bar);
      var group = bar.closest('[data-sj-tabgroup]') || document;

      function select(id, focus) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-sj-tab') === id;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          if (on && focus) t.focus();
        });
        $$('[data-sj-panel]', group).forEach(function (p) {
          p.hidden = p.getAttribute('data-sj-panel') !== id;
        });
      }

      bar.addEventListener('click', function (ev) {
        var t = ev.target.closest('[data-sj-tab]');
        if (t) select(t.getAttribute('data-sj-tab'), false);
      });

      bar.addEventListener('keydown', function (ev) {
        var i = tabs.indexOf(document.activeElement);
        if (i === -1) return;
        var next = null;
        if (ev.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (ev.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (ev.key === 'Home') next = tabs[0];
        else if (ev.key === 'End') next = tabs[tabs.length - 1];
        if (next) { ev.preventDefault(); select(next.getAttribute('data-sj-tab'), true); }
      });
    });
  }

  /* ------------------------------------------- quantity stepper ------ */
  function initQty(root) {
    $$('[data-sj-qty]', root).forEach(function (wrap) {
      if (wrap.__sj) return;
      wrap.__sj = true;
      var input = $('input', wrap);
      if (!input) return;
      var target = document.getElementById(wrap.getAttribute('data-sj-qty-target') || '');
      var max = parseInt(input.getAttribute('max') || '99', 10);
      var min = parseInt(input.getAttribute('min') || '1', 10);

      function sync() {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < min) v = min;
        if (v > max) v = max;
        input.value = String(v);
        if (target) target.value = String(v);
        var card = wrap.closest('[data-sj-card]');
        if (card) paintEntries(card, v);
      }

      wrap.addEventListener('click', function (ev) {
        var b = ev.target.closest('button[data-step]');
        if (!b) return;
        ev.preventDefault();
        input.value = String((parseInt(input.value, 10) || min) + parseInt(b.getAttribute('data-step'), 10));
        sync();
      });
      input.addEventListener('change', sync);
      input.addEventListener('input', sync);
      sync();
    });
  }

  /* ------------------------------------------- variant selects ------- */
  function initVariants(root) {
    $$('[data-sj-variant-select]', root).forEach(function (sel) {
      if (sel.__sj) return;
      sel.__sj = true;
      var card = sel.closest('[data-sj-card]');
      if (!card) return;
      var idInput = $('input[name="id"]', card);
      var priceEl = $('[data-sj-price]', card);
      var btn = card.querySelector('button[name="add"], button[type="submit"]');

      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        if (idInput) idInput.value = opt.value;
        var cents = parseInt(opt.getAttribute('data-price') || '0', 10);
        if (priceEl && cents) priceEl.textContent = money(cents);
        card.setAttribute('data-price-cents', String(cents));
        paintEntries(card, currentQty(card));
        var avail = opt.getAttribute('data-available') === 'true';
        if (btn) { btn.disabled = !avail; btn.setAttribute('aria-disabled', avail ? 'false' : 'true'); }
      });
    });
  }

  function currentQty(card) {
    var q = $('[data-sj-qty] input', card);
    return q ? (parseInt(q.value, 10) || 1) : 1;
  }

  /* ------------------------------------------------ entries ---------- */
  /* Entry amounts always come from the store's own data:
       - a per product override from the entry endpoint when one exists
       - otherwise price x the live multiplier
     Nothing is hard coded in the theme. */
  var MULT = null;
  var OVERRIDES = {};

  function computeEntries(card, qty) {
    var cents = parseInt(card.getAttribute('data-price-cents') || '0', 10);
    var pid = card.getAttribute('data-product-id');
    var over = OVERRIDES[pid];
    var per;
    if (over && over > 0) per = over;
    else {
      var m = MULT || parseFloat(card.getAttribute('data-fallback-multiplier') || '0');
      if (!m || !cents) return null;
      per = Math.round((cents / 100) * m);
    }
    return per * (qty || 1);
  }

  function paintEntries(card, qty) {
    var el = $('[data-sj-entries]', card);
    if (!el) return;
    var total = computeEntries(card, qty || currentQty(card));
    if (total == null || total <= 0) { el.hidden = true; return; }
    el.hidden = false;
    var numEl = $('[data-sj-entries-num]', el);
    if (numEl) numEl.textContent = nf(total);
  }

  function repaintAll(root) { $$('[data-sj-card]', root || document).forEach(function (c) { paintEntries(c); }); }

  function loadEntryData(root) {
    var cards = $$('[data-sj-card]', root || document);
    if (!cards.length) return;

    fetch(MULT_URL, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (m) {
        if (m && m.success && m.totalMultiplier) MULT = Number(m.totalMultiplier);
        repaintAll(root);
      })
      .catch(function () { repaintAll(root); });

    var ids = [];
    cards.forEach(function (c) {
      var id = c.getAttribute('data-product-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    if (!ids.length) return;

    for (var i = 0; i < ids.length; i += 40) {
      (function (chunk) {
        fetch(ENTRIES_URL + '?products=' + encodeURIComponent(chunk.join(',')), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (!d || !d.success || !d.products) return;
            Object.keys(d.products).forEach(function (k) {
              var rec = d.products[k];
              if (rec && rec.hasOverride && rec.entries > 0) OVERRIDES[k] = Number(rec.entries);
            });
            repaintAll(root);
          })
          .catch(function () {});
      })(ids.slice(i, i + 40));
    }
  }

  /* ------------------------------------- added confirmation + bar ---- */
  function showAdded(card) {
    if (!card) return;
    var ok = $('[data-sj-added]', card);
    if (!ok) return;
    ok.hidden = false;
    clearTimeout(card.__sjT);
    card.__sjT = setTimeout(function () { ok.hidden = true; }, 4500);
  }

  function updateBar() {
    var bar = $('[data-sj-cartbar]');
    if (!bar) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) { bar.hidden = true; return; }
        bar.hidden = false;
        var c = $('[data-sj-cartbar-count]', bar);
        var s = $('[data-sj-cartbar-total]', bar);
        if (c) c.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
        if (s) s.textContent = money(cart.total_price);
      })
      .catch(function () {});
  }

  /* The theme fires cart:update for every add, from any component. */
  document.addEventListener('cart:update', function () { updateBar(); });

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-sj-card] button[name="add"], [data-sj-card] button[type="submit"]');
    if (!btn) return;
    var card = btn.closest('[data-sj-card]');
    setTimeout(function () { showAdded(card); }, 500);
  });

  /* ------------------------------------------------ boot ------------- */
  function boot(scope) {
    var base = (scope && scope.querySelectorAll) ? scope : document;
    var roots = $$('[data-sj-enter]', base);
    if (!roots.length && base.matches && base.matches('[data-sj-enter]')) roots = [base];
    if (!roots.length) return;
    roots.forEach(function (root) {
      initTabs(root);
      initQty(root);
      initVariants(root);
      loadEntryData(root);
    });
    updateBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);

  document.addEventListener('shopify:section:load', function (ev) { boot(ev.target); });

  window.SJEnter = { boot: boot, refreshBar: updateBar };
})();
